import React from 'react';
import Image from 'next/image';

import { ITestimonialFields } from '../../../types/contentful';

import { Testimonial as StyledTestimonial } from './styles';
import { Quote, Body, BlockText } from './Testimonial.styles';

import quoteMarks from '@/images/quote-marks.svg';

interface Props extends ITestimonialFields {
  color: string;
}

export function Testimonial({ name, body, color }: Props) {
  return (
    <StyledTestimonial color={color} data-testid="testimonial-block">
      <Quote>
        <Image src={quoteMarks} alt="quote-marks" />
      </Quote>
      <Body as="p">{body}</Body>
      <BlockText as="p" fontWeight={'600'}>
        {name}
      </BlockText>
    </StyledTestimonial>
  );
}
